<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_fees_payment'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="row">
                <b-form-group class="col-md-3" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                    label="name"
                  ></v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>
                <div class="col mt-4 mb-4 justify-content-end d-flex">
                  <h5>
                    <b>Total Online Payments :</b>
                    <span
                      style="font-weight: bold;font-size: 20px;color: green;"
                    >
                      {{ commas(totalpaid) }}
                    </span>
                  </h5>
                  <b-button
                    class="mx-3"
                    size="sm"
                    variant="info"
                    v-if="userData.permissions['view_tandipay'] == 1"
                    ><i class="mdi mdi-cellphone"> </i
                    ><a
                      href="https://tandipay.com/login"
                      target="_blank"
                      class="text-decoration-none text-white"
                      >Visit TandiPay</a
                    ></b-button
                  >
                </div>
                <!-- <div class="mb-2 float-end">
                <b-button v-b-modal.online size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> Make Online Payment</b-button
                >
              </div> -->

                <div class="clearfix"></div>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show
                        <b-form-select
                          class="form-select form-select-sm mx-1"
                          v-model="perPage"
                          size="sm"
                          :options="Options"
                        ></b-form-select>
                        entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="Items"
                    :fields="Fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="Filtered"
                    :busy="IsBusy"
                  >
                    <template #table-busy
                      ><div class="text-center text-primary my-2">
                        <b-spinner
                          class="align-middle"
                          type="grow"
                          small
                        ></b-spinner>
                        <strong>No Data Found</strong>
                      </div></template
                    >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(student)="data">
                      {{ data.item.student_id.first_name }}
                      {{ data.item.student_id.last_name }}<br />
                      <b class="text-danger">{{
                        data.item.student_id.student_id
                      }}</b>
                    </template>
                    <template #cell(term)="data">
                      {{ data.item.term.name }} -
                      {{ data.item.year }} </template
                    ><template #cell(amount)="data">
                      <span style="font-weight: bold;color: green;">{{
                        commas(data.item.amount)
                      }}</span>
                    </template>

                    <template #cell(detail)="data">
                      {{ data.item.details }}
                    </template>
                    <template #cell(telephone)="data">
                      <strong> {{ data.item.telephone }}</strong>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="List"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          id="online"
          centered
          title="Make Online Payment"
          title-class="font-18"
          hide-footer
        >
          <form @submit.prevent="addOnline">
            <label>Student : </label>
            <multiselect
              v-model="student"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            ></multiselect>

            <label>Amount</label>
            <b-form-input v-model="amount" type="number"></b-form-input>

            <div class="form-group d-flex justify-content-end">
              <b-button
                type="button"
                class="btn w-30"
                variant="secondary"
                @click="$bvModal.hide('online')"
                >Close</b-button
              >
              <!-- <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button> -->
              <b-button
                type="submit"
                class="btn ms-1 w-30"
                variant="primary"
                :disabled="loader"
              >
                <b-spinner
                  v-if="loader"
                  small
                  class="mr-1"
                  label="Small Spinner"
                /><i v-else class="fas fa-check-circle"></i> Submit</b-button
              >
            </div>
          </form>
        </b-modal>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  onlinepaymentsComputed,
  onlinepaymentsMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Online payments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Online payments",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Online payments", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student", label: "Student", visible: true },
        { key: "term", label: "School Term", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "detail", label: " Reference", visible: true },
        { key: "telephone", label: "Paid By", visible: true },
        { key: "paid_on", label: "Paid On", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      schoolterm: "",
      reference: "",
      amount: "",
      student_id: "",
      student: "",
      paid_on: "",
      term: "",
      pay_type: "",
      detail: "",
      telephone: "",
      year: new Date().getFullYear(),
      loader: false,
    };
  },
  computed: {
    ...onlinepaymentsComputed,
    ...schooltermComputed,
    ...studentComputed,
    List() {
      return this.onlinepayments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.onlinepayments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.onlinepayments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalpaid() {
      var total = 0;
      this.onlinepayments.forEach((item) => {
        var item_total = item.amount;
        total = Number(total) + Number(item_total);
      });
      return total;
    },

    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchOnlinePayments();
    this.fetchSchoolTerms();
    this.fetchStudents();
    this.TotalRows = this.onlinepayments.length;
    this.isBusy = false;
  },
  methods: {
    ...onlinepaymentsMethods,
    ...schooltermMethods,
    ...studentMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name} `;
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    FilterData() {
      this.filterOnlinePayments({
        schoolterm: this.schoolterm.id,
        year: this.year,
      });
    },
    async addOnline() {
      this.loader = true;
      let formData = new FormData();
      formData.append("amount", this.amount);
      formData.append("studentid", this.student.student.student_id);
      let url = "/generatepaymentlink";
      await axios.post(url, formData).then((response) => {
        // if (response.status == 200) {
        const paymentLink = response.data;
        window.open(paymentLink, "_blank");
        this.fetchOnlinePayments();
        this.$bvModal.hide("online");
        // this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        this.loader = false;
        //}
      });
    },
  },
};
</script>
